const parseOperatorGroups = (operatorGroups) => {
  if (!operatorGroups || !operatorGroups.size) return [];
  return operatorGroups.valueSeq().toArray().map(operatorGroup => ({
    id: operatorGroup.get('id'),
    name: operatorGroup.get('name'),
  }));
};

export default parseOperatorGroups;




// WEBPACK FOOTER //
// ./src/helpers/parseOperatorGroups.js